import { render } from "./InspectorViews.vue?vue&type=template&id=c8a6eac6"
import script from "./InspectorViews.vue?vue&type=script&lang=js"
export * from "./InspectorViews.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__